<template>
    <v-container class="ma-0 pa-0">
        <v-row justify="end" class="mt-2" v-if="respuestas.respuesta">
            <v-col cols="6" class="d-flex justify-end">
                <p class="ma-0" >Respondió: <strong> {{ etiquetaRespondio }} </strong> </p>
            </v-col>
        </v-row>
        <v-row justify="end" class="mt-1" v-if="respuestas.respuesta">
            <v-col cols="8" class="d-flex justify-end py-0">
                <p class="pa-2 ma-0 mb-4 mensajeDer">
                <span class="d-flex justify-end">
                    {{ respuestas.respuesta }}
                </span>
                <span style="font-size: small;">{{ respuestas.fecharespuesta }}</span>
                </p>
            </v-col>
        </v-row>
        <v-row justify="end" class="mt-1" v-if="respuestas.evidenciasRespuesta.length && respuestas.respuesta">
            <v-col cols="3" v-for="(img, i) in respuestas.evidenciasRespuesta" :key="i">
                <v-card
                  class="py-2 shadowCard evidencia-card"
                  @click="verImagen(img, i)"
                  @contextmenu.prevent="descargarEvidencia(img)"
                >
                <EvidenciaMini
                  :src="urlImagen(img) + img.foto"
                  :video="!!img.video"
                  :pdf="!!img.pdf"
                  :nombre="img.foto"
                  :aspect-ratio="1"
                />
                </v-card>
            </v-col>
        </v-row>

        <Imagen
          @close="closeImagen"
          :respuestaImagen="respuestaImagen"
          :isOpen="dialogImagen"
          :imagen="imagen"
          :imagenes="evidenciasActuales"
          :indiceInicial="indiceInicial"
          :ticket="ticket"
        />
    </v-container>
</template>
<script>
import axios from 'axios'
import Imagen from '@/components/tickets/Imagen.vue'
import EvidenciaMini from '@/components/tickets/EvidenciaMini.vue'
import { getEvidenciaBaseUrl, descargarEvidencia } from '@/utils/ticketEvidencias'

export default {
    props: [
        'ticket',
        'respuestas'
    ],
    components:{
        Imagen,
        EvidenciaMini,
    },
    data: () => ({
        url:'',
        dialogImagen:false,
        respuestaImagen: false,
        imagen: '',
        evidenciasActuales: [],
        indiceInicial: 0,
        /** Mismo id ficticio que api-rh/scripts/tickets/ticket_agente_ia.js */
        ID_AGENTE_IA: 900001,
    }),
    computed: {
        etiquetaRespondio () {
            const id = Number(this.respuestas && this.respuestas.idjefe_area)
            if (id === this.ID_AGENTE_IA) return 'Agente IA'
            // Respuestas viejas del bot firmadas como Equipo de Soporte KPI (antes usaban id 334)
            const texto = String((this.respuestas && this.respuestas.respuesta) || '')
            if (/Equipo de Soporte KPI/i.test(texto)) return 'Agente IA'
            return (this.respuestas && this.respuestas.jefe) || '—'
        },
    },
    created () {
        this.url = axios.defaults.baseURL + 'evidencia-tickets/'
    },
    methods:{
        urlImagen(img) {
            return getEvidenciaBaseUrl(this.ticket, img.es_solucion)
        },
        verImagen(img, indice) {
            this.imagen = img.foto
            this.respuestaImagen = img.es_solucion
            this.evidenciasActuales = this.respuestas.evidenciasRespuesta
            this.indiceInicial = indice
            this.dialogImagen = true
        },
        closeImagen(){
            this.dialogImagen = false
        },
        descargarEvidencia(img) {
            descargarEvidencia(this.ticket, img.foto, img.es_solucion)
        },
    },
}
</script>
<style>
  .mensajeIzq{
    white-space: pre-line;
    background-color: rgb(238, 235, 235);
    border-radius: 0px 10px 10px 10px;
  }
  .mensajeDer{
    white-space: pre-line;
    background-color: rgb(193, 231, 243);
    border-radius: 10px 0px 10px 10px;
  }
  .evidencia-card {
    cursor: pointer;
  }
</style>
